//components
import { ShowAt } from 'react-hide-show-utils';
import { Navbar, Nav, NavDropdown} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import OpenEmail from './open-email.js';

//images
import MainLogo from '../assets/images/home-page/MainLogo.svg';
import TwitterIcon from '../assets/images/home-page/Twit-icon.svg';
import InstaIcon from '../assets/images/home-page/IG-icon.svg';
import FBIcon from '../assets/images/home-page/FB-icon.svg';

import '../app/App.css';


function NavbarComponent() {
  return (
    <Navbar collapseOnSelect expand="xl" data-bs-theme="dark" fluid="true" className="navbar-styling" >
      <ShowAt breakpoint="(min-width: 1920px)">
        <img src={MainLogo} alt="Boba Logo" className="d-inline-block"/>{' '}
      </ShowAt>
      <Navbar.Brand href="#home" as={Link} to="/" className="title-text navbar-title">
        bobaface
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler"/>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ms-lg-auto justify-content-end">
          <NavDropdown.Item href="#how-to-play" as={Link} to="/how-to-play" 
            className="navbar-text dropdown-navbar-spacing dropdown-hover">
            play
          </NavDropdown.Item>
          <NavDropdown.Item href="#about" as={Link} to="/about"
            className="navbar-text dropdown-navbar-spacing dropdown-hover">
            about
          </NavDropdown.Item>
          <NavDropdown.Item href="#redeem" as={Link} to="/redeem"
            className="navbar-text dropdown-navbar-spacing dropdown-hover">
              redeem
          </NavDropdown.Item>
          {/*TAKES TO CONTACT US PAGE <NavDropdown.Item href="#contact" as={Link} to="/contact" className="body-text custom-navbar">contact us</NavDropdown.Item> */}
          <NavDropdown.Item 
            style={{marginRight: "8%", marginTop: "1.8%"}} className="dropdown-hover">
            <OpenEmail label="contact us" mailto="mailto:thebobaface@gmail.com" className="navbar-text dropdown-navbar-spacing"/>
          </NavDropdown.Item>
          <ShowAt breakpoint="(min-width: 1920px)">
            <Nav.Link href="https://www.x.com/thebobaface/">
              <img src={TwitterIcon} alt="Twitter"/>
            </ Nav.Link>
            <Nav.Link href="https://www.instagram.com/thebobaface/">
              <img src={InstaIcon} alt="Instagram"/>
            </ Nav.Link>
            <Nav.Link href="https://www.facebook.com/thebobaface/">
              <img src={FBIcon} alt="Facebook"/>
            </ Nav.Link>
          </ShowAt>
        </Nav>
      </Navbar.Collapse>
      </Navbar>
  )
}

export default NavbarComponent;